module.exports = "function cellRendererBody ({ columnIndex, key, rowIndex, style }) {\n  return (\n    <input\n      key={key}\n      onChange={\n        (event) => updateCellValue(key, event.target.value)\n      }\n      style={style}\n      value={getCellValue(key)}\n    />\n  );\n}\n"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./examples/multi-grid-renderers.js
 ** module id = 286
 ** module chunks = 0
 **/